import { render } from "./BlogPostTemplate.vue?vue&type=template&id=2a019016"
import script from "./BlogPostTemplate.vue?vue&type=script&lang=js"
export * from "./BlogPostTemplate.vue?vue&type=script&lang=js"

import "./BlogPostTemplate.vue?vue&type=style&index=0&id=2a019016&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__